import { NewPasswordRule } from './_types'

/**
 * Check if password are identical
 * @param {string} newPassword
 * @param {string} confirmation
 * @returns {boolean} true if there are the same
 */
export const checkPasswordsMatch = (newPassword: string, confirmation: string) => newPassword === confirmation

/**
 * Checks the validity of the password and if both password are identical
 * Length of minimum 8, one letter, one uppercase letter, one number, one special character
 * @param {string} password
 * @param {string} confirmation
 * @returns {Record<NewPasswordRule, boolean>} For each rule a boolean is returned. True if the rule is respected
 */
export const checkPasswordRules = (password: string, confirmation: string): Record<NewPasswordRule, boolean> => {
    const regexes = {
        letter: /[a-zA-Z]+/,
        uppercase_letter: /[A-Z]+/,
        number: /[0-9]+/,
        special_char: /\W|_/g,
    }

    return {
        LENGTH: password.length >= 8,
        HAS_LETTER: regexes.letter.test(password),
        HAS_UPPERCASE_LETTER: regexes.uppercase_letter.test(password),
        HAS_NUMBER: regexes.number.test(password),
        HAS_SPECIAL_CHAR: regexes.special_char.test(password),
        MATCHES: checkPasswordsMatch(password, confirmation),
    }
}
